<form class="flex flex-col gap-4 mb-2" [formGroup]="form">
  <!-- Location -->
  <div class="flex flex-col gap-3">
    <div>
      <label class="block text-body-sm-500 text-surface-700 mb-1.5">Location</label>
      <generic-dropdown
        class="w-full"
        placeholder="Select Location"
        [items]="locationOptions.value()"
        [clearable]="true"
        formControlName="locationId"
      />

      @if (
        (locationOptions.status() === 'idle' || locationOptions.status() === 'resolved') &&
        !locationOptions.value().length
      ) {
        <p-message class="mt-1.5 my-2" severity="error" size="small"
          >No locations available for this product.</p-message
        >
      }
    </div>

    <!-- Attributes -->
    @if (productAttributes().length) {
      <div [formGroup]="attributeValuesGroup" class="flex flex-col gap-4">
        @for (attribute of productAttributes(); track attribute.subCategoryAttributeId) {
          <div>
            <label class="block text-body-sm-500 text-surface-700 mb-1.5">
              {{ attribute.subCategoryAttributeName }}
              @if (product().selectionRequired) {
                <span class="text-red-500 ml-0.5">*</span>
              }
            </label>
            <generic-dropdown
              class="w-full"
              [placeholder]="'Select ' + attribute.subCategoryAttributeName"
              [items]="attributeValueOptions().get(attribute.subCategoryAttributeId) ?? []"
              [clearable]="true"
              [allowSearch]="true"
              [formControlName]="attribute.subCategoryAttributeId"
            />
            @if (!attributeValueOptions().get(attribute.subCategoryAttributeId)?.length) {
              <p class="text-body-xs text-surface-400 m-0 mt-1">No values available for this attribute.</p>
            }
            @if (
              (submitAttempted() || attributeValuesGroup.get(attribute.subCategoryAttributeId)?.touched) &&
              attributeValuesGroup.get(attribute.subCategoryAttributeId)?.invalid
            ) {
              <p class="text-red-500 ml-0.5 mt-1">{{ attribute.subCategoryAttributeName }} is required.</p>
            }
          </div>
        }
      </div>
    }
    @if (noMeasurementDefined()) {
      <p-message class="mt-1.5 my-2" severity="error" size="small"
        >No measurement is defined for this room. Please enter the quantity and unit price manually.</p-message
      >
    }
    @if (productAttributes().length === 0) {
      <div>
        <label class="block text-body-sm-500 text-surface-700 mb-1.5">Attributes</label>
        @if (hasAttributeConfigError()) {
          <p-message class="mt-1.5" severity="error" size="small"
            >Attribute selection is required but attributes are missing. This option cannot be configured.</p-message
          >
        } @else {
          <p class="text-body-sm text-surface-500 font-light text-sm m-0 italic">
            No attributes available for this product.
          </p>
        }
      </div>
    }
  </div>

  <!-- Unit Price -->

  <div>
    <label class="block text-body-sm-500 text-surface-700 mb-1.5"
      >Quantity <span class="text-red-500 ml-0.5">*</span></label
    >
    <p-inputNumber
      class="w-full"
      styleClass="w-full"
      placeholder="Enter Quantity"
      formControlName="quantity"
      [min]="1"
      [showButtons]="false"
    />
  </div>
  <currency-input-field
    class="w-full"
    [label]="'Unit Price'"
    [placeholder]="'Enter Unit Price'"
    formControlName="unitPrice"
    [min]="null"
    [errormessage]="'Unit Price is required.'"
    [customClass]="'form-control'"
    [uomSuffix]="product().uom"
  />

  <!-- Quantity -->

  <!-- Sales Description -->
  <div>
    <label class="block text-body-sm-500 text-surface-700 mb-1.5">Sales Description</label>
    <p class="text-body-sm text-surface-700 m-0">{{ product().salesDescription || '—' }}</p>
  </div>

  <!-- Option Notes -->
  <div>
    <label class="block text-body-sm-500 text-surface-700 mb-1.5">Option Notes</label>
    <textarea pTextarea rows="4" class="w-full" placeholder="Add Notes" formControlName="notes"></textarea>
  </div>
</form>
